// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__juHqp","limit":"Menu_limit__g9OxQ","linksGroup":"Menu_linksGroup__RjFMn","groupLabel":"Menu_groupLabel__dpGGW","menuRocket":"Menu_menuRocket__EDtr3"};